import * as React from "react";
import type { SVGProps } from "react";
const SvgInvestmentPropertyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <g clipPath="url(#investment-property-icon_svg__a)">
      <path
        fill="#858585"
        d="m13.948-.017-.07.017a.56.56 0 0 0-.438.56v1.68H0v19.04h13.44v.875l-4.882 4.883a.57.57 0 0 0 0 .805.57.57 0 0 0 .805 0l4.077-4.078V25.2a.56.56 0 0 0 .278.492c.175.1.39.1.564 0a.56.56 0 0 0 .278-.492v-1.435l4.077 4.078a.57.57 0 0 0 .805 0 .57.57 0 0 0 0-.805l-4.882-4.866v-.892H28V2.24H14.56V.56a.56.56 0 0 0-.613-.577M1.12 3.36h25.76v16.8H14.105a.6.6 0 0 0-.228 0H1.12zm21.84 4.48c-.62 0-1.12.5-1.12 1.12 0 .048.01.094.018.14l-5.74 4.428a1.1 1.1 0 0 0-.438-.088c-.155 0-.304.03-.437.088h-.018l-4.585-3.343q.002-.053 0-.105a1.12 1.12 0 1 0-2.24 0c0 .042.013.08.018.123l-2.94 2.205a1.12 1.12 0 1 0 .683 1.032c-.001-.042-.014-.08-.018-.123l2.94-2.204c.133.056.282.087.437.087s.304-.03.438-.087h.017l4.585 3.342q-.002.053 0 .105a1.12 1.12 0 1 0 2.24 0c0-.048-.01-.094-.018-.14l5.74-4.427h.018c.13.052.271.087.42.087a1.12 1.12 0 1 0 0-2.24"
      />
    </g>
    <defs>
      <clipPath id="investment-property-icon_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInvestmentPropertyIcon;
